import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export default function StringListEditor({
  label,
  helperText,
  items,
  onChange,
}: {
  label: string;
  helperText?: string;
  items: string[];
  onChange: (items: string[]) => void;
}) {
  const update = (index: number, value: string) => {
    const next = [...items];
    next[index] = value;
    onChange(next);
  };

  const remove = (index: number) => {
    onChange(items.filter((_, i) => i !== index));
  };

  const add = () => {
    onChange([...items, ""]);
  };

  return (
    <Box>
      <Typography variant="subtitle2">{label}</Typography>
      {helperText && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 1 }}
        >
          {helperText}
        </Typography>
      )}
      {items.map((item, index) => (
        <Box
          key={index}
          sx={{ display: "flex", gap: 1, mb: 1, mt: 1, alignItems: "center" }}
        >
          <TextField
            value={item}
            onChange={(e) => update(index, e.target.value)}
            fullWidth
            size="small"
          />
          <IconButton
            size="small"
            onClick={() => remove(index)}
            aria-label="Fjern"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      <Button size="small" startIcon={<AddIcon />} onClick={add} sx={{ mt: items.length ? 0 : 1 }}>
        Legg til
      </Button>
    </Box>
  );
}
